import {Component, Input, OnInit} from '@angular/core';
import FabricInterface from '../../../../models/fabric.interface';
import SewingPatternProject from '../../../../models/sewing-pattern-project.model';
import SewingPatternInterface from '../../../../models/sewing-pattern.interface';
import AnalyticsService from '../../../../services/analytics.service';

@Component({
  selector: 'app-fabric-card',
  templateUrl: './fabric-card.component.html',
  styleUrls: ['./fabric-card.component.css'],
})
export class FabricCardComponent implements OnInit {

  @Input() fabric: FabricInterface;
  @Input() sewingPattern: SewingPatternInterface;

  constructor(private analytics: AnalyticsService) { }

  ngOnInit() {}


  async buy(ev, fabric: FabricInterface) {
    const shopUrl = fabric.details.shopUrl ?? fabric.shop.url;

    if (shopUrl) {
      ev.preventDefault();
      ev.stopPropagation();

      this.analytics.logEvent({
        name: 'shop_fabric',
        params: {
          url: shopUrl,
          fabricName: fabric.name,
          fabricId: fabric.id,
          sewingPatternName: this.sewingPattern?.name ?? null,
          sewingPatternId: this.sewingPattern?.id ?? null
        }
      });

      window.open(shopUrl);
    }
  }
}
